import React, { useEffect } from 'react';
import Lottie from 'lottie-react';
import { Center, Fade, VStack, Heading } from '@chakra-ui/react';
import animationData from '../assets/login-success.json';

const sportQuotes = [
  "La altura de la red en el centro de la cancha es de 0.914 metros.",
  "El récord del saque más rápido en el tenis es de 263 km/h.",
  "Wimbledon es el torneo de tenis más antiguo del mundo, jugado desde 1877.",
  "El partido más largo de la historia duró 11 horas y 5 minutos (Isner vs. Mahut, 2010).",
  "Margaret Court tiene el récord de más Grand Slams individuales con 24 títulos.",
  "Novak Djokovic alcanzó 24 títulos de Grand Slam, igualando el récord histórico."
];

export default function LoginSuccessAnimation({ onComplete }) {
  // Llamamos a onComplete a los 3 segundos
  useEffect(() => {
    const timer = setTimeout(onComplete, 3000);
    return () => clearTimeout(timer);
  }, [onComplete]);

  // Elegir frase aleatoria una vez
  const quote = sportQuotes[Math.floor(Math.random() * sportQuotes.length)];

  return (
    <Fade in>
      <Center
        position="fixed"
        top={0}
        left={0}
        w="100vw" h="100vh"
        bg="gray.800"
        zIndex="9999"
      >
        <VStack spacing={8}>
          <Lottie
            animationData={animationData}
            loop={true}     // se queda en bucle hasta que onComplete la descuelgue
            autoplay
            style={{ width: 300, height: 300 }}
          />
          <Heading size="lg" color="white" textAlign="center" maxW="600px" px={4}>
            "{quote}"
          </Heading>
        </VStack>
      </Center>
    </Fade>
  );
}
